import React from "react";

import { i18n } from '../../translate/i18n';
import {CheckCircle, Error, Link, Sync } from "@mui/icons-material";

import { Container, FileInfo, Preview } from "./styles";
import previewSelector from "../../utils/previewSelector";

import filesize from "filesize";
import { Box, Button, CircularProgress } from "@mui/material";
import Spinner from "../../components/Spinner";

export interface IFile {
  _id?: string,
  size: number,
  file: any,
  id: number | string,
  name: string,
  readableSize: string,
  preview: any,
  fileType: string,
  progress: number,
  isNotUploaded: boolean,
  error: boolean,
  url: string | null,
  loading?: boolean,
  source?: string,
}

interface Props {
  files: IFile[],
  onDelete: CallableFunction,
  disabled: boolean,
  retry?: CallableFunction,
}

const iconStyles = {
    circle: "#78e5d5",
    error: "#e57878",
    link: "#e57878"
  };

const FileList = ({ files, onDelete, disabled, retry }: Props) => {

  return (
    <>
      <Container>
        {files.map(uploadedFile => (
          <li key={uploadedFile.id ? uploadedFile.id : uploadedFile._id}>
            <FileInfo>
              <Preview src={previewSelector(uploadedFile)} />

              <Box>
                <strong>{uploadedFile.name}</strong>
                <span>
                  {!uploadedFile._id ? uploadedFile.readableSize : filesize(uploadedFile.size)}{" "}
                  {(!uploadedFile.isNotUploaded || uploadedFile.error) && (
                    <Box
                      onClick={() => !disabled ? onDelete(uploadedFile.id ? uploadedFile.id : uploadedFile._id) : null}
                      style={{
                        opacity: disabled ? '0.3' : '1',
                        cursor: disabled ? 'auto' : 'pointer'
                      }}
                    >
                      {i18n.t('divFileList.text') as string}
                    </Box>
                  )}
                </span>
              </Box>
            </FileInfo>

            <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
              
              {uploadedFile.isNotUploaded && !uploadedFile.error && !uploadedFile._id && (
                <CircularProgress
                  size={24}
                  variant="determinate"
                  value={uploadedFile.progress}
                />
              )}

              {uploadedFile.url && (
                <a
                  href={uploadedFile.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{marginRight: 8, display: 'flex', justifyContent: 'center'}}
                >
                  <Link style={{ fontSize: 24, color: iconStyles.link, height: '100%' }} />
                </a>
              )}

              {(uploadedFile.error && retry) &&
                <Button
                  onClick={() => {uploadedFile.loading = true; retry(uploadedFile); }}
                  variant="outlined"
                  size="small"
                  startIcon={ !uploadedFile.loading && <Sync />}
                  style={{marginRight: 8, color: '#079942', borderColor: '#079942', minWidth: '113px' }}
                >
                  {uploadedFile.loading ? <Spinner size={16} overlay={null}/> : i18n.t('divFileList.retry') as string}
                </Button>
              }

              {!uploadedFile.isNotUploaded && (
                <CheckCircle style={{ fontSize: 24, color: iconStyles.circle }} />
              )}
              {uploadedFile.error && <Error style={{ fontSize: 24, color: iconStyles.error }} />}
              
            </Box>
          </li>
        ))}
      </Container>
    </>
  );
};

export default FileList;
